import { Comments } from '@/components/comments/Comments/Comments';
import {
  useComments,
  useCreateComment,
  useDeleteComment,
  useUpdateComment,
} from '@/models/request';

export const RequestComments = ({
  requestId,
  articleId,
}: {
  requestId: string;
  articleId?: string;
}) => {
  const { data: { comments } = { comments: [] } } = useComments({
    requestId,
    articleId,
  });
  const { mutateAsync: sendUpdateComment } = useUpdateComment({ requestId, articleId });
  const { mutateAsync: sendDeleteComment } = useDeleteComment({ requestId, articleId });
  const { mutateAsync: sendCreateComment, isPending: isCreateCommentPending } = useCreateComment({
    requestId,
    articleId,
  });

  return (
    <Comments
      comments={comments}
      displayArticleName={!articleId}
      isReadOnly={(comment) => comment.article?.id !== articleId}
      isCreatingComment={isCreateCommentPending}
      onCommentCreated={async (data) => {
        await sendCreateComment(data);
      }}
      onCommentUpdated={async (data) => {
        await sendUpdateComment(data);
      }}
      onCommentDeleted={async (data) => {
        await sendDeleteComment(data);
      }}
    />
  );
};
